// extracted by mini-css-extract-plugin
module.exports = {"container":"Radio_container__3H87r","label":"Radio_label__aPUjF"};